const zhCN = {
  backBtn: '返回',
  submitBtn: '提交',

  gateTitle: '门禁设置',

  enableAccessControl: '是否启用门禁功能',
  option_true: '是',
  option_false: '否',

  enableOpenDirectly: '是否启用直接开门功能',

  closingDelay: '关门延时',
  closingDelayTxt: '请输入关门延时',
  closingDelayUnit: '秒',
  closingDelayBlank: '请输入关门延时！',
  closingDelayWarning: '请输入正整数！',
  closingDelayMax: '关门延时最大值不超过60秒！',
  closingDelayMin: '关门延时最小值不低于1秒！',

  communicationMethods: '通讯方式',
  communicationMethodsTxt: '请选择通讯方式',
  communicationMethodsBlank: '请选择通讯方式！',
  option_relay: '继电器',
  option_wiggins26: '韦根26',
  option_wiggins34: '韦根34',

  identifyWays: '识别方式',
  identifyWaysTxt: '请选择识别方式',
  identifyWaysBlank: '请选择识别方式！',

  option_ICCard: '门禁卡核验',
  option_face: '人脸比对核验',
  option_IDCard: '身份证核验',
  option_ICAndFR: '门禁卡+人脸核验',  
  option_IDAndFaceComparison: '人证核验',
  option_FaceCollection: '人脸采集',
  option_IDCollection: '身份证采集',
  option_IDAndSitePhoto: '身份证采集+人脸采集',
  option_DynamicKey: '动态密钥',  

  enableRecogFlashing: '是否启用识别提示闪烁',

  enableRecogVoice: '是否启用识别提示声音',

  doorDirection: '门禁方向',
  option_enter: '进门',
  option_out: '出门',

  setSignInDevice: '设置为签到设备'

  // visitorType: '访客身份类型',
  // options_scheduled: '预约访客',
  // options_temporary: '临时访客',

  // scheduledVIdentifyWays: '预约访客识别方式',
  // scheduledVIdentifyWaysTxt: '请选择预约访客识别方式',
  // scheduledVIdentifyWaysBlank: '请选择预约访客识别方式',
  // option_IDCard: '身份证开门',
  // option_IDAndFace: '身份证+人脸验证组合开门',

  // temporaryVIdentifyWays: '临时访客识别方式',
  // temporaryVIdentifyWaysTxt: '请选择临时访客识别方式',
  // temporaryVIdentifyWaysBlank: '请选择临时访客识别方式！',

  // option_IDCardCollection: '采集身份证开门',
  // option_personAndID: '人证合一验证开门',
  // option_IDCollectionAndFace: '采集身份证+人脸开门'
}
const enUS = {
  backBtn: 'Back',
  submitBtn: 'Submit',

  gateTitle: 'Gate Settings',

  enableAccessControl: 'Enable Access Control',
  option_true: 'True',
  option_false: 'False',

  enableOpenDirectly: 'Enable Open Door Directly',

  closingDelay: 'Closing Delay',
  closingDelayTxt: 'Enter closing delay',
  closingDelayUnit: 'second',
  closingDelayBlank: 'Closing delay can\'t be blank!',
  closingDelayWarning: 'Please enter a positive integer!',
  closingDelayMax: 'The maximum closing delay is not more than 60 seconds!',
  closingDelayMin: 'The minimum value of closing delay is not less than a second!',

  communicationMethods: 'Communication Methods',
  communicationMethodsTxt: 'Choose communication methods',
  communicationMethodsBlank: 'Communication methods can\'t be blank!',
  option_relay: 'Relay',
  option_wiggins26: 'Wiggins 26',
  option_wiggins34: 'Wiggins 34',

  identifyWays: 'Identify Ways',
  identifyWaysTxt: 'Choose identify ways',
  identifyWaysBlank: 'Identify ways can\'t be blank!',

  option_ICCard: 'IC Card',
  option_face: 'Face Recognition',
  option_IDCard: 'ID Card',
  option_ICAndFR: 'IC Card & Face Recognition',  
  option_IDAndFaceComparison: 'Face and ID Comparison',
  option_FaceCollection: 'Face Collection',
  option_IDCollection: 'Id Card Collection',
  option_DynamicKey: 'Dynamic Key',

  enableRecogFlashing: 'Enable Flashing with Recognition',

  enableRecogVoice: 'Enable Voice with Recognition',

  doorDirection: 'Door Direction',
  option_enter: 'Enter',
  option_out: 'Out',

  setSignInDevice: 'Set to sign in device'

  // visitorType: 'Visitor Status',
  // options_scheduled: 'Scheduled',
  // options_temporary: 'Temporary',

  // scheduledVIdentifyWays: 'Scheduled Visitor Identify Ways',
  // scheduledVIdentifyWaysTxt: 'Choose scheduled visitor identify ways',
  // scheduledVIdentifyWaysBlank: 'Choose scheduled visitor identify ways!',
  // option_IDCard: 'ID Card',
  // option_IDAndFace: 'ID Card & Face Recognition',

  // temporaryVIdentifyWays: 'Temporary Visitor Identify Way',
  // temporaryVIdentifyWaysTxt: 'Choose temporary visitor identify ways',
  // temporaryVIdentifyWaysBlank: 'Choose temporary visitor identify ways!',
  // option_IDCardCollection: 'ID Card Collection',
  // option_personAndID: 'Combination of person and ID',
  // option_IDCollectionAndFace: 'ID Card Collection & Face Recognition'
}

export default { zhCN, enUS }